import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY !== 0) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <div style={{ position: 'relative', zIndex: '10' }}>
            <footer className="footer" id="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                            <div className="fotter_hedding">
                                <p>MU Gems - Gracefully You is an exclusive house of fabric inspired by tradition, that goes
                                    beyond the ordinary to celebrate creativity. Choose from an array of high-quality fabric
                                    materials, traditional artistry & latest designs.</p>
                                <div className="socel_midia">
                                    <ul>
                                        <li><Link to="https://www.facebook.com/" target="_blank" rel="noreferrer"><i
                                            className="fa-brands fa-facebook" ></i></Link></li>
                                        <li><Link to="https://www.instagram.com/" rel="noreferrer" target="_blank"><i
                                            className="fa-brands fa-instagram"></i></Link></li>
                                        <li><Link to="https://www.youtube.com/" rel="noreferrer" target="_blank"><i
                                            className="fa-brands fa-youtube"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                            <div className="fotter_hedding">
                                <h2>Quick links</h2>
                                <div className="quick_links">
                                    <ul className="p-0">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/about-us">About Us</Link></li>
                                        <li><Link to="/contact-us">Contact Us </Link></li>
                                        <li><Link to="/myprofile">My Account</Link></li>
                                    </ul>
                                    <ul>
                                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                                        <li><Link to="/returnandrefundpolicy">Refund & Return Policy</Link></li>
                                        <li><Link to="/faq">FAQ</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                            <div className="map_wepper">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227748.43601989333!2d75.62574184210932!3d26.88542139271588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1723545993457!5m2!1sen!2sin"
                                    width="100%" height="250" style={{ border: '0' }} allowFullScreen="" loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <p>Copyright © All Rights Reserved.
                        <span className="right"><span>Designed By </span>
                            <a href="https://ishivax.com/" target="_blank" rel="noopener noreferrer">
                                iShivax®</a></span>
                    </p>
                </div>
            </footer>
            <section>

                {/* <!-- Arrow Top --> */}
                <div className="scroll-area">
                    <div className="top-wrap">
                        <div className="go-top-btn-wraper">
                            <div
                                className={`go-top go-top-button ${isVisible ? "active" : ""}`}
                                id="toTop"
                                style={{ display: isVisible ? "block" : "none" }}
                                onClick={scrollToTop}
                            >
                                <i className="fa fa-angle-double-up"></i>
                                <i className="fa fa-angle-double-up"></i>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Arrow Top End --> */}

                {/* <!-- Whatsapp Icon Start --> */}
                <div className="wa-chat-icon">
                    <a href="https://wa.me/919898989898?text=Hi" target="_blank">
                        <img src="../../images/whatsapp-icon.png" /></a>
                </div>
                {/* <!-- Whatsapp Icon END --> */}
            </section>
        </div>
    )
}

export default Footer;